/* eslint-disable @typescript-eslint/no-namespace */
import moment, { Moment } from 'moment';

import { DataExport } from './data-export';
import { DealExportViewModel } from '../../types/export.types';
import { DealComment } from '../../types/deal-comments.types';

export namespace DealCommentDataExport {
  import ExportFormatProvider = DataExport.ExportFormatProvider;
  import ExportDataValueProvider = DataExport.ExportDataValueProvider;
  import ExportColumnDefinition = DataExport.ExportColumnDefinition;
  export class DealCommentExportColumn extends ExportColumnDefinition {
    public formatProvider?: ExportFormatProvider;
    public conditionToInclude?: (data: DealExportViewModel) => boolean;
    public optional: boolean;
    constructor(
      public headerName: string,
      public valueProvider: ExportDealCommentValueProvider,
      options?: {
        formatProvider?: ExportFormatProvider;
        conditionToInclude?: (data: DealExportViewModel) => boolean;
        mappers?: ((value: any) => any)[];
      }
    ) {
      super(options as unknown);
    }
  }
  export interface ExportDealCommentValueProvider
    extends ExportDataValueProvider {
    getValue(comment: DealComment): any;
  }

  export const authorValueProvider: ExportDealCommentValueProvider = {
    getValue(comment: DealComment): string {
      return comment.createdByName;
    }
  };

  export const creationDateValueProvider: ExportDealCommentValueProvider = {
    getValue(comment: DealComment): Moment {
      return moment(comment.creationDate);
    }
  };

  export const contentValueProvider: ExportDealCommentValueProvider = {
    getValue(comment: DealComment): string {
      return comment.content;
    }
  };

  export const attachmentsValueProvider: ExportDealCommentValueProvider = {
    getValue(comment: DealComment): string[] {
      return comment.attachments.map((a) => a.name);
    }
  };
}
